export const INVALID_NUMBER_VALIDATION_TYPES = {
  BLANK: 'The value cannot be blank',
  NON_NUMERIC_CHARACTERS: 'The value contains non-numeric characters',
  NOT_A_NUMBER: 'The value is not a valid number',
  TOO_SMALL: 'The value is smaller than the minimum allowed',
  TOO_BIG: 'The value is larger than the maximum allowed',
};

export const NUMERIC_INPUT_ID = 'custom-value-override';
